<template>
  <div class="header-app" :style="{ background: getPrimaryColor() }">
    <div
      :class="`p-3 font-white font14 ${$route.path.split('/').includes('profile') ? 'show-in-mobile d-flex align-items-center' : 'd-none'}`"
      v-if="authUser"
      :style="{ background: getPrimaryColor() }"
      @click="$router.go(-1)"
    >
      <font-awesome-icon class="font20 mr-2 font-white" :icon="['far', 'arrow-left']" />
      Back
    </div>
    <div :class="`dovemed-wrapper justify-content-between headerHeight ${$route.path.split('/').includes('profile') && 'hide-in-mobile'}`" :style="{ display: 'flex' }">
      <div :class="`align-items-center ${showSearchBar ? 'hide-in-mobile' : 'd-flex'}`" v-if="currentCircle">
        <!-- <a-icon
          @click="showMenuL"
          class="m-icon"
          type="bars"
          v-if="$route.path.includes('home')"
        /> -->
        <div class="d-flex align-items-center header-logo">
          <img class="logo" :src="currentCircle.url ? currentCircle.url : defaultCircleLogo" alt="logo" />
          <!-- <div class="beta" :style="{ color: getPrimaryColor() }">
            <div class="beta-version">
              Beta
            </div>
          </div> -->
        </div>
      </div>
      <template>
        <!-- <div
          class="header-search-bar"
          v-if="
            this.authUser &&
              $route.name !== 'ProfileSelect' &&
              $route.name !== 'CircleDescription'
          "
        >
          <a-input
            :value="filterPost"
            v-model="filterPost"
            placeholder="Search for posts"
            size="large"
          />

          <button
            :style="{ 'background-color': getSecondaryColor() }"
            class="header-search-bar--button"
            @click="handleSearchPost"
          >
            Search
          </button>
        </div> -->
        <form
          @submit.prevent="handleSearchPost"
          :class="`header-search-bar ${showSearchBar ? 'show-in-mobile' : 'hide-in-mobile'}`"
          v-if="this.authUser && $route.name !== 'ProfileSelect' && $route.name !== 'CircleDescription'"
        >
          <font-awesome-icon size="1x" :icon="['far', 'search']" class="p-2 hide-in-mobile" :style="{ color: getPrimaryColor() }" />
          <font-awesome-icon size="1x" :icon="['far', 'times']" class="p-2 show-in-mobile" :style="{ color: getPrimaryColor() }" @click="toggleSearchBar" />
          <input v-model="filterPost" placeholder="Search something..." size="large" class="searchInputMain fw700" />
          <font-awesome-icon
            v-if="filterPost"
            size="1x"
            :icon="['far', 'times']"
            class="p-2 gray400 cp hide-in-mobile"
            @click="
              () => {
                filterPost = ''
                handleSearchPost()
              }
            "
          />
          <button :style="{ 'background-color': getSecondaryColor() }" class="header-search-bar--button m-1" @click="handleSearchPost">Search</button>
        </form>
      </template>
      <div v-if="this.authUser && $route.name !== 'ProfileSelect' && $route.name !== 'CircleDescription'" :class="`${showSearchBar ? 'hide-in-mobile' : ''}`">
        <ul class="navigator p-0 m-0">
          <li class="show-in-mobile">
            <font-awesome-icon :icon="['far', 'search']" :style="{ 'font-size': '22px' }" class="font-white header-nav-icon mr-3" @click="toggleSearchBar" />
          </li>

          <li @click="goToHome" class="font-white position-relative iconToHover hide-in-mobile">
            <span class="position-absolute tooltip-text" :style="{ background: getSecondaryColor() }"> Go To Activity Page </span>
            <!-- <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              class="svg-inline--fa fa-house-chimney-blank header-nav-icon"
              :style="{ 'font-size': '22px' }"
              data-icon="house-chimney-blank"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
            >
              <path
                fill="#ffffff"
                d="M511.8 287.6L512.5 447.7C512.6 483.2 483.9 512 448.5 512H128.1C92.75 512 64.09 483.3 64.09 448V287.6H32.05C14.02 287.6 0 273.5 0 255.5C0 246.5 3.004 238.5 10.01 231.5L266.4 8.016C273.4 1.002 281.4 0 288.4 0C295.4 0 303.4 2.004 309.5 7.014L416 100.7V64C416 46.33 430.3 32 448 32H480C497.7 32 512 46.33 512 64V185L564.8 231.5C572.8 238.5 576.9 246.5 575.8 255.5C575.8 273.5 560.8 287.6 543.8 287.6L511.8 287.6z"
              ></path>
            </svg> -->
            <svg
              :style="{ 'font-size': '22px' }"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              class="svg-inline--fa fa-house-blank header-nav-icon"
              data-icon="house-blank"
              role="img"
            >
              <path
                fill="#ffffff"
                d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
              />
            </svg>
          </li>

          <!-- <li class="bell-button-mobile">
            <font-awesome-icon
              size="1x"
              @click="handleNotificationMobile"
              class="position-relative"
              :icon="['fas', 'bell']"
            />
          </li> -->

          <!-- Notifications -->
          <li class="hide-in-mobile">
            <a-dropdown placement="bottomRight" :trigger="['click']" v-model="dropDownVisible">
              <!-- @visibleChange="visibleChange" -->
              <!-- class="bell-button-desktop" -->
              <a class="ant-dropdown-link position-relative iconToHover" @click="handleNotifications" href="#">
                <span class="position-absolute tooltip-text" :style="{ background: getSecondaryColor() }"> Open Notification Dropdown </span>
                <span class="dropdown-btn-class bell-size d-flex font-white" :style="{ 'margin-right': '0px' }">
                  <font-awesome-icon class="position-relative header-nav-icon" :icon="['fas', 'bell']" />
                  <span v-if="unreadNotificationCount" class="notification-dot" :style="{ background: getNotification500Color() }">
                    {{ unreadNotificationCount > 20 ? "20+" : unreadNotificationCount }}
                  </span>
                </span>
              </a>
              <a-menu class="notification-dropdown" slot="overlay" :style="{ 'max-height': '450px', 'overflow-y': 'scroll', 'font-weight': '700', 'font-size': '18px' }">
                <a-menu-item key="0" class="d-flex justify-content-between position-relative" style="cursor: default">
                  <div :style="{ 'font-weight': '700', 'font-size': '24px', color: '#0F1734 !important' }">Notifications</div>
                  <!-- <div
                    :style="{
                      color: getPrimaryColor(),
                      'font-size': '16px'
                    }"
                    @click="$router.push({ name: 'Notification' })"
                  >
                    View all
                  </div> -->
                  <font-awesome-icon class="cp font24" :style="{ color: '#94A3B8' }" :icon="['far', 'ellipsis-v']" @click.stop="() => (showNotificationsOptions = !showNotificationsOptions)" />
                  <div
                    class="position-absolute shadow-card notiOptsContainer"
                    v-if="showNotificationsOptions"
                    @click.stop="
                      () => {
                        showNotificationsOptions = false
                        dropDownVisible = false
                      }
                    "
                  >
                    <p v-if="unreadNotificationCount" @click="markAllRead">
                      <font-awesome-icon :icon="['fal', 'check']" class="font-black mx-2" />
                      Mark all as read
                    </p>
                    <p v-if="!$route.path.includes('notificationsettings')" @click="$router.push({ name: 'NotificationSettings' })">
                      <font-awesome-icon :icon="['fal', 'cog']" class="font-black mx-2" />
                      Notification settings
                    </p>
                    <p v-if="!$route.path.includes('notifications') || $route.path.includes('notificationsettings')" @click="$router.push({ name: 'Notification' })" class="hide-in-mobile">
                      <font-awesome-icon :icon="['fal', 'eye']" class="font-black mx-2" />
                      View all notifications
                    </p>
                  </div>
                </a-menu-item>

                <a-menu-item key="1" style="cursor: default">
                  <div class="mb-2 gray800 fw700 font16">Today</div>
                  <div>
                    <div v-for="(notification, index) in todayNoti" :key="index" :style="{ background: !notification.is_read ? '#dfe7f5' : '#faf8f8', width: '100%', cursor: 'pointer' }">
                      <div class="d-flex mr-4 mb-3 align-items-center" :style="{ height: '90px' }" @click="() => notificationRouter(notification)">
                        <font-awesome-icon v-if="hideNotiUser(notification.notification_text)" :icon="['fas', 'flag']" class="font24 p23 error300 bg-error50 rounded-circle mr-3 ml-2" />
                        <a-avatar
                          alt="avatar"
                          :style="{ color: ' #ffffff !important', 'background-color': notification.sender_user[0].url ? '' : getAvatarColor(notification.sender_user[0].id) }"
                          :size="70"
                          class="post-list-image round-img small-avatar-image ml-2 text-capitalize"
                          :src="notification.sender_user.length ? notification.sender_user[0].url : ''"
                          v-else
                        >
                          {{
                            notification.sender_user[0].firstName
                              ? notification.sender_user[0].firstName[0]
                              : notification.sender_user[0].display_name
                              ? notification.sender_user[0].display_name[0]
                              : notification.sender_user[0].first_name[0]
                          }}
                        </a-avatar>
                        <div>
                          <div class="notif-text mb-0">
                            <div v-if="notification.sender_user.length">
                              <span class="text-truncate gray800 fw700 font16 text-capitalize">
                                {{
                                  hideNotiUser(notification.notification_text)
                                    ? "Someone"
                                    : ["doctor", "physician"].includes(notification.sender_user[0].role) && notification.notification_text === "added you to circle"
                                    ? `Doctor ${notification.sender_user[0].display_name}`
                                    : notification.sender_user[0].display_name
                                }}
                              </span>
                            </div>
                            <p class="mb-0 gray800 text-capitalize font16">
                              {{
                                getNewNotificationText(
                                  notification.notification_text,
                                  notification.sender_user[0].display_name,
                                  notification.sender_user[0].role,
                                  notification.sender_user[0].gender,
                                  notification.receiver_user[0].role
                                )
                              }}
                            </p>
                          </div>
                          <p class="notif-text-small mb-0 gray400">
                            {{ formatPostTime(notification.notification_time)[0] }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="notiE gray800" v-if="!isToday" :style="{ 'font-weight': '700', 'font-size': '16px', 'text-align': 'center' }">No New Notifications</div>
                </a-menu-item>
                <a-menu-item key="2" style="cursor: default" v-if="isEarli">
                  <div class="mb-2">
                    <div class="mb-2 gray800 font16 font700">Earlier</div>
                    <div v-if="earlierNoti.length">
                      <div v-for="(notification, index) in earlierNoti" :key="index" :style="{ background: !notification.is_read ? '#dfe7f5' : '#faf8f8', width: '100%', cursor: 'pointer' }">
                        <div class="d-flex mr-4 mb-3 align-items-center" :style="{ height: '90px' }" @click="() => notificationRouter(notification)">
                          <font-awesome-icon v-if="hideNotiUser(notification.notification_text)" :icon="['fas', 'flag']" class="font24 p23 error300 bg-error50 rounded-circle mr-3 ml-2" />
                          <a-avatar
                            v-else
                            alt="avatar"
                            :style="{ color: ' #ffffff !important', 'background-color': notification.sender_user[0].url ? '' : getAvatarColor(notification.sender_user[0].id) }"
                            :size="70"
                            class="post-list-image round-img small-avatar-image ml-2 text-capitalize"
                            :src="notification.sender_user.length ? notification.sender_user[0].url : ''"
                          >
                            {{
                              notification.sender_user[0].firstName
                                ? notification.sender_user[0].firstName[0]
                                : notification.sender_user[0].display_name
                                ? notification.sender_user[0].display_name[0]
                                : notification.sender_user[0].first_name[0]
                            }}
                          </a-avatar>
                          <div>
                            <div class="notif-text mb-0">
                              <div v-if="notification.sender_user.length">
                                <span class="text-truncate gray800 fw700 font16 text-capitalize">
                                  {{
                                    hideNotiUser(notification.notification_text)
                                      ? "Someone"
                                      : ["doctor", "physician"].includes(notification.sender_user[0].role) && notification.notification_text === "added you to circle"
                                      ? `Doctor ${notification.sender_user[0].display_name}`
                                      : notification.sender_user[0].display_name
                                  }}
                                </span>
                              </div>
                              <p class="mb-0 gray800 text-capitalize font16">
                                {{
                                  getNewNotificationText(
                                    notification.notification_text,
                                    notification.sender_user[0].display_name,
                                    notification.sender_user[0].role,
                                    notification.sender_user[0].gender,
                                    notification.receiver_user[0].role
                                  )
                                }}
                              </p>
                            </div>
                            <p class="notif-text-small mb-0 gray400">
                              {{ formatPostTime(notification.notification_time)[0] }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="!isEarli && todayNoti.length < 4" :style="{ 'font-weight': '700', 'font-size': '16px', 'text-align': 'center' }" class="gray800">No Old Notifications</div>
                  </div>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </li>

          <li class="position-relative iconToHover hide-in-mobile">
            <font-awesome-icon @click="goToMeetOthers" :style="{ 'font-size': '20px' }" class="header-nav-icon" :icon="['fas', 'user-plus']" />
            <span class="position-absolute tooltip-text" :style="{ background: getSecondaryColor() }"> Add users to your Circle </span>
          </li>
          <!-- <li class="r-sidebar-icon" @click="showMenuR">
            <a-avatar
              :style="{
                color: ' #ffffff !important',
                'background-color': (authUser.user ? authUser.user.url : ``)
                  ? ''
                  : '#C997C5',
              }"
              :size="40"
              class="header-profile-image text-capitalize"
              :src="authUser.user ? authUser.user.url : ``"
            >
              {{
                authUser.user.firstName
                  ? authUser.user.firstName[0]
                  : authUser.user.display_name
                  ? authUser.user.display_name[0]
                  : authUser.user.first_name[0]
              }}
            </a-avatar>
          </li> -->

          <!-- PROFILE -->
          <!-- <li class="h-hide-res" @click="handleProfileMultiRole"> -->
          <li @click="handleProfileMultiRole" class="hide-in-mobile">
            <a-dropdown :placement="'bottomRight'" :trigger="['click']">
              <div class="d-flex cursor-pointer" :style="{ 'align-items': 'center' }">
                <span class="size font-white">
                  <a-avatar
                    :style="{
                      color: ' #ffffff !important',
                      'background-color': authUser.user.url ? '' : getAvatarColor(authUser.user.id),
                      border: authUser.user.url ? '1px solid transparent' : '1px solid #F8FAFD',
                    }"
                    :size="40"
                    class="header-profile-image text-capitalize avatar-border fw700"
                    :src="authUser.user ? authUser.user.url : ``"
                    alt="avatar"
                  >
                    <!-- :alt="() => getAuthUserInitials()" -->
                    <!-- outline: authUser.user.url ? 'none' : '1px solid #F8FAFD', -->
                    <!-- {{
                      authUser.user.first_name
                        ? authUser.user.first_name[0].toUpperCase()
                        : authUser.user.display_name
                        ? authUser.user.display_name[0].toUpperCase()
                        : authUser.user.first_name[0].toUpperCase()
                    }}

                    {{
                        authUser.user.last_name? authUser.user.last_name[0].toUpperCase():""
                    }} -->
                    <!-- <span style="transform: scale(1.5) translate(-50%, -1%) !important"> -->
                    {{ getAuthUserInitials() }}
                    <!-- </span> -->
                  </a-avatar>
                </span>
                <div class="text-left ml-2 h-hide-res">
                  <span class="d-block font-white text-capitalize">
                    {{
                      authUser.user.role === "patient" || authUser.user.role === "caregiver" || authUser.user.role === "advocate"
                        ? authUser.user.display_name
                        : authUser.user.role === "doctor"
                        ? "Dr. " + (authUser.user.first_name ? authUser.user.first_name + " " + authUser.user.last_name : authUser.user.display_name)
                        : authUser.user.first_name
                        ? authUser.user.first_name + " " + authUser.user.last_name
                        : authUser.user.display_name
                    }}
                  </span>
                  <!-- <span v-if="authUser.user.role === 'hospital_administrator' || authUser.user.role === 'clinic_administrator'" class="admin-tag d-block text-capitalize"> Administrator </span> -->
                </div>
              </div>

              <a-menu slot="overlay" class="profile-dropdown" :style="{ borderRadius: '10px', width: '360px' }">
                <a-menu-item>
                  <div rel="noopener noreferrer" v-if="authUser.user && currentCircle.id">
                    <!-- <div
                      v-if="isMultirole"
                      @click="goToSelectRolePage"
                      class="switch-roles"
                      :style="{ color: getPrimaryColor() }"
                    >
                      Switch roles
                    </div> -->

                    <div class="d-flex align-middle" @click="showProfile">
                      <div>
                        <!-- <a-avatar
                          :src="authUser.user ? authUser.user.url : ``"
                          icon="user"
                          alt="avatar"
                          :size="60"
                        /> -->
                        <a-avatar
                          :style="{ color: ' #ffffff !important', 'background-color': authUser.user.url ? '' : getAvatarColor(authUser.user.id) }"
                          :size="70"
                          :src="authUser.user ? authUser.user.url : ``"
                          class="text-capitalize"
                          alt="profile picture"
                        >
                          <!-- {{
                            authUser.user.firstName
                              ? authUser.user.firstName[0]
                              : authUser.user.display_name
                              ? authUser.user.display_name[0]
                              : authUser.user.first_name[0]
                          }} -->
                          {{ getAuthUserInitials() }}
                        </a-avatar>
                      </div>
                      <div class="d-flex flex-column justify-content-center ml-3">
                        <!-- <img src="authUser.user ? authUser.user.url : ``" alt="" class="post-list-image"> -->
                        <p class="profile-name text-wrap text-capitalize ml-0 mb-1">
                          <!-- {{
                            authUser.user.role === "doctor"
                              ? "Dr" +
                                "." +
                                authUser.user.first_name +
                                " " +
                                authUser.user.last_name
                              : authUser.user.display_name
                          }} -->
                          {{
                            authUser.user.role === "doctor"
                              ? "Dr. " + (authUser.user.first_name ? authUser.user.first_name + " " + authUser.user.last_name : authUser.user.display_name)
                              : authUser.user.first_name
                              ? authUser.user.first_name + " " + authUser.user.last_name
                              : authUser.user.display_name
                          }}
                        </p>
                        <div class="" v-if="authUser.user.role === 'business_administrator'">
                          <span class="post-physician py-1 px-2 orange-text orange-bg font12">
                            <font-awesome-icon :icon="['far', 'store']" class="mr-1" />
                            Business
                          </span>
                        </div>
                        <div class="" v-if="authUser.user.role === 'hospital_administrator'">
                          <span class="post-physician py-1 px-2 orange-text orange-bg font12">
                            <font-awesome-icon :icon="['far', 'hospital-alt']" class="mr-1" />
                            Hospital
                          </span>
                        </div>
                        <div class="" v-if="authUser.user.role === 'clinic_administrator'">
                          <span class="post-physician py-1 px-2 orange-text orange-bg font12">
                            <font-awesome-icon :icon="['far', 'hospital']" class="mr-1" />
                            Clinic
                          </span>
                        </div>
                        <div class="p-0" v-if="authUser.user.role === 'doctor' || authUser.user.role === 'physician'">
                          <span class="post-physician py-1 px-2 orange-bg orange-text font12">
                            <font-awesome-icon :icon="['far', 'user-md']" class="mr-1" />
                            Physician
                          </span>
                        </div>
                        <div class="p-0" v-if="authUser.user.role === 'hcp' || authUser.user.role === 'ohcp'">
                          <span class="post-physician py-1 px-2 orange-bg orange-text font12">
                            <font-awesome-icon :icon="['far', 'user-nurse']" class="mr-1" />
                            Advanced Practice Provider
                          </span>
                        </div>
                        <div class="post-physician py-1 px-2 m-0 font12 orange-bg orange-text" v-if="authUser.user.role === 'nfp' || authUser.user.role === 'nfp_administrator'">
                          <font-awesome-icon :icon="['far', 'hand-holding-heart']" class="mr-1" />
                          Non For Profit
                        </div>
                        <div v-if="authUser.user.role === 'advocate'" class="post-physician py-1 px-2 font12" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }">
                          <font-awesome-icon :icon="['fas', 'bullhorn']" class="mr-1" />
                          Advocate
                        </div>
                      </div>
                    </div>
                  </div>
                </a-menu-item>
                <a-menu-item>
                  <!-- <hr /> -->
                  <div class="current-circle mt-4 gray800">
                    My Circles
                    <div class="d-flex justify-content-between align-items-center mt-4">
                      <div class="rounded-circle mr-1 hw24" :style="{ background: getPrimaryColor() }"></div>
                      <p class="font-weight-normal text-capitalize mb-0 flex-grow-1" :style="{ 'white-space': 'initial', 'max-width': '200px' }">
                        {{ currentCircle.condition_type }}
                      </p>
                      <div @click="goToSelectRolePage" class="switch-roles gray500 font10" :style="{ width: '80px', 'text-align': 'right' }">SWITCH ROLE</div>
                    </div>

                    <!-- <div class="d-flex justify-content-between align-items-center mt-3" v-if="otherCircle.condition_type">
                      <div class="rounded-circle mr-1 hw24" :style="{ background: otherCircle ? otherCircle.color_code : '#fff' }"></div>
                      <p class="font-weight-normal text-capitalize mb-0 flex-grow-1" :style="{ 'white-space': 'initial', 'max-width': '200px' }">
                        {{ otherCircle.condition_type }}
                      </p>
                      <div class="font10" :style="{ color: getPrimaryColor(), width: '80px', 'text-align': 'right' }" @click="goToThisCircle(otherCircle)">ENTER</div>
                    </div> -->

                    <div class="d-flex justify-content-between align-items-center mt-3" v-for="circles in recentlyJoinedCircles" :key="circles.id">
                      <div class="rounded-circle mr-1 hw24" :style="{ background: circles.color_code }"></div>
                      <p class="font-weight-normal text-capitalize mb-0 flex-grow-1" :style="{ 'white-space': 'initial', 'max-width': '200px' }">
                        {{ circles.condition_type }}
                      </p>
                      <div class="font10" :style="{ color: getPrimaryColor(), width: '80px', 'text-align': 'right' }" @click="goToThisCircle(circles)">ENTER</div>
                    </div>

                    <div class="viewCircleBG mt-4" :style="{ color: getPrimaryColor() }" @click="goToAllCirclesPage">
                      View all my Circles
                      <font-awesome-icon :icon="['far', 'arrow-right']" class="p-2 font20" :style="{ color: getPrimaryColor() }" />
                    </div>
                  </div>
                  <!-- <hr /> -->
                </a-menu-item>
                <a-menu-item>
                  <!-- @click="showProfile" -->
                  <!-- :href="`${process.env.SSO_BASE_URL}`" -->
                  <a :href="SSO_BASE_URL" target="_blank" class="profile-menu-item gray800 mt-2" rel="noopener noreferrer" :style="{ 'font-size': '16px', 'font-weight': '400' }">
                    Go to DoveMed Profile
                  </a>
                </a-menu-item>
                <!-- <a-menu-item>
                  <a
                    class="profile-menu-item"
                    rel="noopener noreferrer"
                    @click="$router.push({ name: 'AccountSettings' })"
                    >ACCOUNT SETTINGS</a
                  >
                </a-menu-item> -->
                <!-- <a-menu-item>
                  <a
                    class="profile-menu-item"
                    rel="noopener noreferrer"
                    @click="$router.push({ name: 'NotificationSettings' })"
                  >
                    NOTIFICATION SETTINGS
                  </a>
                </a-menu-item> -->
                <!-- <router-link :to="{ name: 'NotificationSettings'}">NOTIFICATION SETTINGS</router-link> -->
                <a-menu-item>
                  <hr />
                </a-menu-item>
                <a-menu-item style="margin-top: 32px" class="text-center">
                  <!-- <a rel='noopener noreferrer' @click="logout">LOGOUT</a> -->
                  <button @click="handleLogout" :style="{ background: getSecondaryColor(), 'font-size': '14px' }" class="dovemed-button primary-button font-white w-100">Log Out</button>
                  <!-- <a rel='noopener noreferrer' @click="logout">Logout</a> -->
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </li>
        </ul>
      </div>
      <div v-else>
        <div class="d-flex align-items-center">
          <div
            v-if="authUser"
            class="hide-in-mobile"
            @click="
              $router.push({
                name: 'AllCircles',
              })
            "
          >
            <div class="text-white cp font14 fw700">Home</div>
          </div>

          <div
            v-if="authUser"
            @click="$router.push({ name: 'JoinedCircle' })"
            :class="
              `rounded header-myC font14 fw700 text-white cp 
              ${$route.path.includes('select-profile') ? 'hide-in-mobile' : ''}`
            "
          >
            My Circles
          </div>

          <div v-if="authUser" class="ml-4">
            <a-dropdown :trigger="['click']">
              <a class="ant-dropdown-link" @click="e => e.preventDefault()" href="#">
                <a-avatar
                  :style="{
                    color: '#ffffff !important',
                    'background-color': getAvatarColor(authUser.user.id),
                    border: '1px solid #F8FAFD',
                  }"
                  :size="40"
                  class="fw700"
                  alt="avatar"
                >
                  <!-- outline: '1px solid #F8FAFD', -->
                  <!-- {{
                    authUser.user.firstName
                      ? authUser.user.firstName[0]
                      : authUser.user.display_name
                      ? authUser.user.display_name[0]
                      : authUser.user.first_name[0]
                  }} -->
                  <!-- {{ getAuthUserInitials() }} -->
                  {{
                    authUser.user.email
                      ? authUser.user.email[0].toUpperCase()
                      : authUser.user.firstName
                      ? authUser.user.firstName[0].toUpperCase()
                      : authUser.user.display_name
                      ? authUser.user.display_name[0].toUpperCase()
                      : "D"
                  }}
                </a-avatar>
              </a>
              <a-menu slot="overlay" class="mt-3">
                <a-menu-item key="0" class="header-profile-pop-list">
                  <div v-if="$route.path.includes('select-profile') || $route.path.includes('signup')" class="d-flex align-items-center mw343 mt15">
                    <div class="flex-center-center hw70 rounded-circle fw700 font24 text-white text-capitalize" :style="{ border: '1px solid #F8FAFD', background: getAvatarColor(authUser.user.id) }">
                      {{ userInfo.email[0] }}
                    </div>
                    <p class="mb-0 ml-3 fw700 font18 text-black">
                      {{ userInfo.email || "D" }}
                    </p>
                  </div>
                  <div v-else class="d-flex align-items-center mw343 mt15">
                    <div class="flex-center-center hw70 rounded-circle fw700 font24 text-white" :style="{ border: '1px solid #F8FAFD', background: getAvatarColor(authUser.user.id) }">
                      {{ getAuthUserInitials() }}
                    </div>
                    <p class="mb-0 ml-3 fw700 font18 text-black text-capitalize">
                      {{ authUser.user.first_name || authUser.user.display_name || "D" }}
                    </p>
                  </div>
                  <button class="w-100 fw700 bg-gray200 br6 p1224 mt-4 flex-center-center mw343" :style="{ border: 'none', color: getPrimaryColor() }" @click="$router.push({ path: '/searchpage' })">
                    View all my Circles
                    <font-awesome-icon :icon="['far', 'arrow-right']" class="font20 ml-auto" :style="{ color: getPrimaryColor() }" />
                  </button>
                  <button class="w-100 fw700 bg-gray900 br6 mt-4 p1224 text-white d-block mw343" :style="{ border: 'none', background: getSecondaryColor() }" @click="handleLogout">Logout</button>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
          <div v-else>
            <div @click="$router.push({ path: '/' })" :style="{ color: '#ffffff', 'font-size': '12px', 'font-weight': 'bold', cursor: 'pointer' }">Home</div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="mobile-tabs show-in-mobile d-flex align-items-center justify-content-between"
      v-if="
        ($route.path.includes('home') || $route.path.includes('notifications') || $route.path.includes('update-dovedaily') || $route.path.includes('slideshow')) &&
          !$route.path.includes('notificationsettings')
      "
    >
      <div @click="goToHome">
        <font-awesome-icon
          size="2x"
          :style="{ color: $route.path.includes('activity') && !mobileSideMenuClicked ? getPrimaryColor() : '#0F1734' }"
          :icon="[`${$route.path.includes('activity') && !mobileSideMenuClicked ? 'fas' : 'fal'}`, 'window-maximize']"
        />
        Activity
      </div>
      <div @click="goToMeetOthers">
        <font-awesome-icon
          size="2x"
          :style="{ color: $route.path.includes('meetothers') && !mobileSideMenuClicked ? getPrimaryColor() : '#0F1734' }"
          :icon="[`${$route.path.includes('meetothers') && !mobileSideMenuClicked ? 'fas' : 'fal'}`, 'user-plus']"
        />
        Meet Others
      </div>
      <div @click="goToMedicalDirectory">
        <font-awesome-icon
          size="2x"
          :style="{ color: $route.path.includes('medicaldirectories') && !mobileSideMenuClicked ? getPrimaryColor() : '#0F1734' }"
          :icon="[`${$route.path.includes('medicaldirectories') && !mobileSideMenuClicked ? 'fas' : 'fal'}`, 'briefcase-medical']"
        />
        Medical Directory
      </div>
      <!-- <div
        @click="
          () => {
            if (dropDownVisibleMob) {
              dropDownVisibleMob = false
            }
          }
        "
      >
        <li class="m-noti-main-container">
          <a-dropdown class="noti-class" placement="bottomRight" :trigger="['click']" v-model="dropDownVisibleMob">
            <a class="ant-dropdown-link" @click="handleNotifications">
              <div class="dropdown-btn-class d-flex font-white flex-column">
                <font-awesome-icon
                  class="position-relative header-nav-icon gray900"
                  :icon="[`${dropDownVisibleMob ? 'fas' : 'fal'}`, 'bell']"
                  :style="{
                    color: dropDownVisibleMob ? getPrimaryColor() : '#0F1734',
                  }"
                  size="2x"
                />
                <span v-if="unreadNotificationCount" class="notification-dot">
                  {{ unreadNotificationCount }}
                </span>
                Notifications
              </div>
            </a>
            <a-menu
              class="notification-dropdown"
              slot="overlay"
              :style="{
                'max-height': '450px',
                'overflow-y': 'scroll',
                'font-weight': '700',
                'font-size': '18px',
              }"
            >
              <a-menu-item key="0" class="d-flex justify-content-between position-relative">
                <div
                  :style="{
                    'font-weight': '700',
                    'font-size': '24px',
                    color: '#0F1734 !important',
                  }"
                >
                  Notifications
                </div>
                <font-awesome-icon
                  class="cp"
                  size="1x"
                  :style="{
                    color: '#94A3B8',
                    'font-size': '24px',
                  }"
                  :icon="['far', 'ellipsis-v']"
                  @click.stop="() => (showNotificationsOptions = !showNotificationsOptions)"
                />
                <div class="position-absolute shadow-card notiOptsContainer" v-if="showNotificationsOptions" @click.stop="() => (showNotificationsOptions = false)">
                  <p @click="markAllRead">
                    <font-awesome-icon size="1x" :icon="['fal', 'check']" class="font-black mx-2" />
                    Mark all as read
                  </p>
                  <p
                    @click="
                      () => {
                        dropDownVisibleMob = false
                        $router.push({ name: 'NotificationSettings' })
                      }
                    "
                  >
                    <font-awesome-icon size="1x" :icon="['fal', 'cog']" class="font-black mx-2" />
                    Notification settings
                  </p>
                </div>
              </a-menu-item>

              <a-menu-item key="1">
                <div class="mb-2 gray800 fw700 font16">Today</div>
                <div>
                  <div
                    v-for="(notification, index) in todayNoti"
                    :key="index"
                    :style="{
                      background: !notification.is_read ? '#dfe7f5' : '#faf8f8',
                      width: '100%',
                    }"
                  >
                    <div class="d-flex mr-4 mb-3 align-items-center" :style="{ height: '90px' }" @click="() => notificationRouter(notification)">
                      <a-avatar
                        :style="{
                          color: ' #ffffff !important',
                          'background-color': notification.sender_user.length ? notification.sender_user[0].url : getAvatarColor(notification.sender_user[0]),
                        }"
                        :size="60"
                        class="post-list-image round-img small-avatar-image ml-2 text-capitalize"
                        :src="notification.sender_user.length ? notification.sender_user[0].url : ''"
                      >
                        {{
                          notification.sender_user[0].firstName
                            ? notification.sender_user[0].firstName[0]
                            : notification.sender_user[0].display_name
                            ? notification.sender_user[0].display_name[0]
                            : notification.sender_user[0].first_name[0]
                        }}
                      </a-avatar>
                      <div>
                        <div class="notif-text mb-0">
                          <div v-if="notification.sender_user.length">
                            <span class="text-truncate gray800 fw700 font16">
                              {{ notification.sender_user[0].display_name }}
                            </span>
                          </div>
                          <p class="mb-0 gray800 text-capitalize font16">
                            {{ notification.notification_text }}
                          </p>
                        </div>
                        <p class="notif-text-small mb-0 gray400">
                          {{ formatPostTime(notification.notification_time)[0] }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="notiE gray800"
                  v-if="!isToday"
                  :style="{
                    'font-weight': '700',
                    'font-size': '16px',
                    'text-align': 'center',
                  }"
                >
                  No New Notifications
                </div>
              </a-menu-item>
              <a-menu-item key="2">
                <div class="mb-2">
                  <div class="mb-2 gray800 font700 font16">Earlier</div>
                  <div v-if="earlierNoti.length">
                    <div
                      v-for="(notification, index) in earlierNoti"
                      :key="index"
                      :style="{
                        background: !notification.is_read ? '#dfe7f5' : '#faf8f8',
                        width: '100%',
                      }"
                    >
                      <div class="d-flex mr-4 mb-3 align-items-center" :style="{ height: '90px' }" @click="() => notificationRouter(notification)">
                        <a-avatar
                          :style="{
                            color: ' #ffffff !important',
                            'background-color': notification.sender_user[0].url ? '' : getAvatarColor(notification.sender_user[0].id),
                          }"
                          :size="60"
                          class="post-list-image round-img small-avatar-image ml-2 text-capitalize"
                          :src="notification.sender_user.length ? notification.sender_user[0].url : ''"
                        >
                          {{
                            notification.sender_user[0].firstName
                              ? notification.sender_user[0].firstName[0]
                              : notification.sender_user[0].display_name
                              ? notification.sender_user[0].display_name[0]
                              : notification.sender_user[0].first_name[0]
                          }}
                        </a-avatar>
                        <div>
                          <div class="notif-text mb-0">
                            <div v-if="notification.sender_user.length">
                              <span class="text-truncate gray800 fw700 font16">
                                {{ notification.sender_user[0].display_name }}
                              </span>
                            </div>
                            <p class="mb-0 gray800 text-capitalize font16">
                              {{ notification.notification_text }}
                            </p>
                          </div>
                          <p class="notif-text-small mb-0 gray400">
                            {{ formatPostTime(notification.notification_time)[0] }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="!isEarli"
                    :style="{
                      'font-weight': '700',
                      'font-size': '16px',
                      'text-align': 'center',
                    }"
                    class="gray800"
                  >
                    No Old Notifications
                  </div>
                </div>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </li>
      </div> -->
      <div @click="goToNoti" class="position-relative">
        <font-awesome-icon
          size="2x"
          :style="{
            color: $route.path.includes('notifications') && !mobileSideMenuClicked ? getPrimaryColor() : '#0F1734',
          }"
          :icon="[`${$route.path.includes('notifications') && !mobileSideMenuClicked ? 'fas' : 'fal'}`, 'bell']"
        />
        <span v-if="unreadNotificationCount" class="notification-dot" :style="{ background: getNotification500Color() }">
          {{ unreadNotificationCount > 20 ? "20+" : unreadNotificationCount }}
        </span>
        Notifications
      </div>
      <div>
        <!-- <a-icon
          @click="showMenuL"
          class="m-icon gray900"
          type="bars"
          :style="{ color: '#0f1734', fill: '#0f1734' }"
        /> -->
        <font-awesome-icon
          @click="handleMobileMenu"
          size="2x"
          :icon="[`${checkIfMoreWantsHighlight() ? 'fas' : 'fal'}`, 'bars']"
          :style="{
            color: checkIfMoreWantsHighlight() ? getPrimaryColor() : '#0F1734',
          }"
        />
        More
      </div>
    </div>
    <NotificationModal ref="notificationModal" />
    <div v-if="logoutProcess" class="spinnerContainer">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory"
import moment from "moment"
import NotificationModal from "../Modals/NotificationModal.vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faUserPlus } from "@fortawesome/pro-solid-svg-icons"
import { faSearch, faTimes } from "@fortawesome/pro-regular-svg-icons"
import { faEye, faCheck, faCog, faBell } from "@fortawesome/pro-light-svg-icons"

library.add(faUserPlus, faSearch, faEye, faCheck, faCog, faTimes, faBell)

const AppRepository = RepositoryFactory.get("app")
const CircleRepository = RepositoryFactory.get("circle")
const UserRepository = RepositoryFactory.get("user")
const PostRepository = RepositoryFactory.get("posts")

export default {
  name: "Header",
  data() {
    return {
      notifications: [],
      currentPage: 1,
      limit: 4,
      pagination: {},
      logo: null,
      circleLogo: null,
      defaultCircleLogo: null,
      filterPost: undefined,
      // isMultirole: false,
      todayNoti: [],
      earlierNoti: [],
      isEarli: false,
      isToday: false,
      unreadNotificationCount: 0,
      showNotificationsOptions: false,
      logoutProcess: false,
      // otherCircle: { condition_type: "", color_code: "#fff" },
      showSearchBar: false,
      // mobileSideMenuClicked: false,
      dropDownVisible: false,
      dropDownVisibleMob: false,
      previousCircleId: null,
      recentlyJoinedCircles: [],
      interval: null,
      userInfo: null,
      notification_loading: false,
    }
  },
  computed: {
    SSO_BASE_URL: () => process.env.SSO_BASE_URL,
  },
  components: {
    NotificationModal,
  },
  watch: {
    "$route.params": function(oldVal, newVal) {
      // console.log('Header.vue -> watching $route.params');
      this.fetchUserNotifications()
    },
    currentCircle: {
      async handler() {
        // this.otherCircle = this.authUser.user.circles.find(circle => circle.id !== this.currentCircle.id && circle.condition_type !== this.currentCircle.condition_type) || {
        //   condition_type: "",
        //   color_code: "#fff",
        // }
        // console.log("(watch) - otherCircle ->", this.otherCircle.condition_type)
        try {
          if (this.authUser && this.authUser.user && !this.authUser.user.hasOwnProperty("verified_account")) {
            const res = await UserRepository.getMyRecentlyJoinedCircles(this.currentCircle.id)
            // console.log("getMyRecentlyJoinedCircles -> res.data.data:", res.data.data)
            this.recentlyJoinedCircles = res.data.data
            // this.recentlyJoinedCircles = res.data.data.map(circle => circle.circle_details[0])
            // console.log("recentlyJoinedCircles", this.recentlyJoinedCircles)
          }
        } catch (e) {}
      },
      immediate: true,
      deep: true,
    },
    dropDownVisible(v) {
      if (!v) {
        this.dropDownVisible = this.showNotificationsOptions
        this.showNotificationsOptions = false
      }
    },
  },

  destroyed() {
    clearInterval(this.interval)
  },

  created() {
    console.warn("Header.vue is created")
    this.refreshCircleData();
    this.userInfo = JSON.parse(localStorage.getItem("user-full-info"))
    this.interval = setInterval(() => {
      if (!this.$route.path.includes("select-profile") && this.notification_loading === false) {
        this.fetchUserNotifications()
      }
    }, 5000)
    window.addEventListener("mouseup", () => {
      if (this.showNotificationsOptions) {
        setTimeout(() => {
          this.showNotificationsOptions = false
        }, 100)
      }
    })
    // this.fetchPosts();
    // this.fetchUserNotifications();
    this.defaultCircleLogo = require("../../assets/dovemed-logo.svg")
    // CircleRepository.all("", "").then(res => {
    //   res.data.data.all_circles.forEach(circle => {
    //     if (circle.condition_type === this.currentCircle.condition_type) {
    //       this.circleLogo = circle.url;
    //     }
    //   });
    // });
  },

  async mounted() {
    console.warn("Header.vue is mounted")

    // circle A -> circle B -> circle A
    // if (!this.previousCircleId) {
    //   this.previousCircleId = this.currentCircle.id
    //   return
    // }
    // if (this.currentCircle.id === this.previousCircleId) {
    // }

    // this.otherCircle = this.authUser.user.circles.find(circle => circle.id !== this.currentCircle.id && circle.condition_type !== this.currentCircle.condition_type) || {
    //   condition_type: "",
    //   color_code: "#fff",
    // }
    // console.log("(mounted) - otherCircle ->", this.otherCircle.condition_type)
  },

  methods: {
    refreshCircleData(){
      CircleRepository.all("", this.currentCircle.id)
        .then(res => {
          let circle = res.data.data.all_circles[0]
          this.$store.dispatch("Circle/diseaseTypes", { type: circle.id })
          this.$store.commit("Circle/setCurrentCircle", { data: circle })
        })
        .catch(err => {
          console.log(err)
        })
    },
    checkIfMoreWantsHighlight() {
      if (
        this.mobileSideMenuClicked ||
        this.$route.path.includes("mycirclestats") ||
        this.$route.path.includes("mydovedirectory") ||
        this.$route.path.includes("dovemedrecommended") ||
        this.$route.path.includes("recommendations") ||
        this.$route.path.includes("reviews") ||
        this.$route.path.includes("meetAdvocates") ||
        this.$route.path.includes("resources") ||
        this.$route.path.includes("qa") ||
        this.$route.path.includes("treatments") ||
        this.$route.path.includes("aboutcircle")
      )
        return true
      return false
    },
    handleMobileMenu() {
      if (this.mobileSideMenuClicked) {
        if (document.querySelector(".l-sidebar").classList.contains("l-sidebar-show")) {
          document.querySelector(".l-sidebar").classList.remove("l-sidebar-show")
          document.querySelector(".backdrop").classList.remove("backdrop-show")
        }
        document.querySelector(".l-sidebar").classList.add("l-sidebar-hide")
        document.querySelector(".backdrop").classList.remove("backdrop-show")
        if (document.querySelector("#app").classList.contains("no-scroll")) {
          document.querySelector("#app").classList.remove("no-scroll")
        }
        setTimeout(() => {
          if (document.querySelector(".r-sidebar").classList.contains("r-sidebar-hide")) {
            document.querySelector(".r-sidebar").classList.remove("r-sidebar-hide")
          }
          if (document.querySelector(".l-sidebar").classList.contains("l-sidebar-hide")) {
            document.querySelector(".l-sidebar").classList.remove("l-sidebar-hide")
          }
        }, 2000)
        // this.mobileSideMenuClicked = false
        this.$store.commit("Circle/setMobileSideMenuClicked", { data: false })
      } else {
        this.showMenuL()
        // this.mobileSideMenuClicked = true
        this.$store.commit("Circle/setMobileSideMenuClicked", { data: true })
      }
    },
    toggleSearchBar() {
      this.showSearchBar = !this.showSearchBar
    },
    markAllRead() {
      this.dropDownVisible = false
      this.dropDownVisibleMob = false
      const headers = {
        Authorization: `Bearer ${this.authUser.user.token}`,
      }
      // `${process.env.BASE_API_URL}/notifications/?user_id=${this.authUser.user.id}&circle_id=${this.currentCircle.id}&allread=true&page_num=${this.currentPage}&items=${this.limit}`,
      this.$http
        .put(`${process.env.BASE_API_URL}/notifications/?user_id=${this.authUser.user.id}&circle_id=${this.currentCircle.id}&role=${this.authUser.user.role}`, { is_read: true }, { headers })
        .then(res => {
          this.fetchUserNotifications()
          // let userNotifications = res.data.data.data || [];
          // this.unreadNotificationCount = 0;
          // this.todayNoti = userNotifications.filter((x) => {
          //   return (
          //     moment(x.notification_time).dayOfYear() == moment().dayOfYear()
          //   );
          // });
          // this.earlierNoti = userNotifications.filter((x) => {
          //   return (
          //     moment(x.notification_time).dayOfYear() !== moment().dayOfYear()
          //   );
          // });
          // this.isToday = this.todayNoti.length > 0 ? true : false;
          // this.isEarli = this.earlierNoti.length > 0 ? true : false;
          // this.pagination = res.data.data.paginator;
        })
        .catch(err => {
          this.fetchUserNotifications()
        })
    },
    goToThisCircle(newCircle) {
      this.$router.push(`/${newCircle.key_name}/select-profile`)
      this.$store.dispatch("Circle/diseaseTypes", { type: newCircle.id })
      this.$store.commit("Circle/setCurrentCircle", { data: newCircle })
      AppRepository.getHasMultiRole(this.currentCircle.id)
        .then(res => {
          if (!res.data.data.length) {
            let selectedRole
            selectedRole = this.$store.state.User.user.user.multiRole.filter(r => r.newCircle_id === this.currentCircle.id)[0].role
            const payload = { role: selectedRole, circle_id: this.currentCircle.id }
            AppRepository.postHasMultiRole(payload).then(res => {
              UserRepository.getSelfProfile(this.authUser.user, newCircle.id).then(res => {
                this.$store.state.User.user.user.display_name = res.data.data.user_info.display_name ? res.data.data.user_info.display_name : "D"
                this.authUser.user.role = selectedRole
                this.$router.push(`/${this.currentCircle.key_name}/home/activity`)
              })
            })
          } else {
            this.$router.replace(`/${this.currentCircle.key_name}/select-profile`)
          }
        })
        .catch(err => {})
    },
    goToHome() {
      if (this.mobileSideMenuClicked) {
        this.handleMobileMenu()
      }
      // if (typeof this.authUser.user.role === "string" || typeof this.authUser.user.multiRole[0].role === "string") {
      //   this.$router.push({ name: "ActivityHome" }).catch(err => {})
      // }
      this.$router.push({ name: "ActivityHome" })
    },
    goToMeetOthers() {
      if (this.mobileSideMenuClicked) {
        this.handleMobileMenu()
      }
      this.$router.push({ name: "MeetOthers" })
    },
    goToMedicalDirectory() {
      if (this.mobileSideMenuClicked) {
        this.handleMobileMenu()
      }
      this.$router.push({ name: "MedicalDirectory" })
    },
    goToNoti() {
      if (this.mobileSideMenuClicked) {
        this.handleMobileMenu()
      }
      this.$router.push({ name: "Notification" })
    },
    // handleNotificationMobile() {
    //   this.$refs.notificationModal.show()
    // },
    handleLogout() {
      this.logoutProcess = true
      console.log("Header -> handleLogout")
      setTimeout(() => {
        this.logout()
        this.$router.push({ path: "/circles" })
      }, 500)
    },
    fetchUserNotifications(e) {
      if (e) {
        e.preventDefault()
      }
      this.notification_loading = true
      AppRepository.getNotifications(this.currentCircle.id, this.currentPage, this.limit, this.authUser.user)
        .then(res => {
          this.notification_loading = false
          let userNotifications = res.data.data.data || []
          this.unreadNotificationCount = 0
          if (userNotifications) {
            // userNotifications.map(ele => {
            //   if (ele.is_read === false) {
            //     this.unreadNotificationCount += 1
            //   }
            // })
            this.unreadNotificationCount = res.data.data.paginator.read_count
          }
          this.todayNoti = userNotifications.filter(x => {
            return moment(x.notification_time).dayOfYear() == moment().dayOfYear()
          })
          this.earlierNoti = userNotifications.filter(x => {
            return moment(x.notification_time).dayOfYear() !== moment().dayOfYear()
          })
          this.isToday = this.todayNoti.length > 0 ? true : false
          this.isEarli = this.earlierNoti.length > 0 ? true : false
          this.pagination = res.data.data.paginator
        })
        .catch(e => (this.notification_loading = false))
    },
    // getHeaderLogo() {
    //   return `url(${this.circleLogo ? this.circleLogo : this.defaultCircleLogo}) `
    // },
    // async init() {
    //   await CircleRepository.all()
    //     .then(async res => {
    //       this.authUser ? (this.allCircles = await this.circleDiff(res.data.data.all_circles)) : (this.allCircles = await res.data.data.all_circles)
    //     })
    //     .catch(err => {})
    // },

    handleProfileMultiRole() {
      this.dropDownVisible = false
      // AppRepository.getHasMultiRole(this.currentCircle.id)
      //   .then(res => {
      //     if (!res.data.data.length || res.data.data.length === 1) {
      //       this.isMultirole = false
      //     } else {
      //       this.isMultirole = true
      //     }
      //   })
      //   .catch(err => {})
    },

    showProfile() {
      const profileType = this.authUser.user.role

      switch (profileType) {
        case "patient":
          this.$router.push({ name: "PatientUpdates" })
          break
        case "caregiver":
          this.$router.push({ name: "CaregiverUpdates" })
          break
        case "advocate":
          this.$router.push({ name: "AdvocateUpdates" })
          break
        case "hospital_administrator":
          this.$router.push({ name: "HosUpdates" })
          break
        case "clinic_administrator":
          this.$router.push({ name: "ClinicUpdates" })
          break
        case "doctor":
          this.$router.push({ name: "DocUpdates" })
          break
        case "hcp":
          this.$router.push({ name: "HcpAbout" })
          break
        case "nfp_administrator":
          this.$router.push({ name: "NFPAbout" })
          break
        case "clinic_profile":
          this.$router.push({ name: "Clinic_Profile" })
          break
        default:
          this.$router.push({ path: `profile/${profileType}/updates` })
          break
      }
    },
    showMenuL() {
      if (document.querySelector(".l-sidebar").classList.contains("l-sidebar-hide")) {
        document.querySelector(".l-sidebar").classList.remove("l-sidebar-hide")
        document.querySelector(".backdrop").classList.add("backdrop-show")
      }
      if (document.querySelector(".r-sidebar").classList.contains("r-sidebar-show")) {
        document.querySelector(".r-sidebar").classList.remove("r-sidebar-show")
      }
      document.querySelector(".l-sidebar").classList.add("l-sidebar-show")
      document.querySelector(".backdrop").classList.add("backdrop-show")
      document.querySelector("#app").classList.add("no-scroll")
    },

    // showMenuR() {
    //   if (document.querySelector(".r-sidebar").classList.contains("r-sidebar-hide")) {
    //     document.querySelector(".r-sidebar").classList.remove("r-sidebar-hide")
    //     document.querySelector(".right-side-backdrop").classList.add("r-backdrop-show")
    //   }
    //   if (document.querySelector(".l-sidebar").classList.contains("l-sidebar-show")) {
    //     document.querySelector(".l-sidebar").classList.remove("l-sidebar-show")
    //   }
    //   document.querySelector(".r-sidebar").classList.add("r-sidebar-show")
    //   document.querySelector(".right-side-backdrop").classList.add("r-backdrop-show")
    //   document.querySelector("#app").classList.add("no-scroll")
    // },

    /**
     * Fetch Notifications
     */
    // fetchNotifications() {
    //   AppRepository.getNotifications(this.currentCircle.id, this.currentPage, this.limit, this.authUser.user)
    //     .then(res => {
    //       this.notifications = res.data.data.data
    //       this.pagination = res.data.data.paginator
    //     })
    //     .catch(err => console.error(err))
    // },

    // notificationRouter(data) {
    //   const id = data.ext_ref_id ? data.ext_ref_id : data.id

    //   AppRepository.readNotifications(id).then(res => {
    //     if (data.element_type) {
    //       let rout = data.element_type
    //       this.$router.push({ name: "Notification" })
    //       if (rout == "add to circle") {
    //         // let user = data.receiver_user;
    //         // if (Array.isArray(user) && user.length > 0) {
    //         //   this.$router.push({
    //         //     path: `profile/view/${data.sender_role}/${data.sender_user[0].id}/about`,
    //         //   });
    //         //   console.log('add to circle')
    //         // }
    //         // return;
    //         this.viewProfile(data.sender_user[0])
    //       } else if (data.element_type === "post") {
    //         this.$router.push({ path: `home/view/post/${data.element_id}` })
    //       } else if (data.element_type === "question") {
    //         this.$router.push({ path: `home/qa/share/${data.element_id}` })
    //       } else if (data.element_type === "poll") {
    //         this.$router.push({
    //           path: `home/resources/poll/${data.element_id}`,
    //         })
    //       } else if (data.element_type === "trivia") {
    //         this.$router.push({
    //           path: `home/resources/trivia/${data.element_id}`,
    //         })
    //       } else if (data.element_type === "slideshow") {
    //         this.$router.push({
    //           path: `home/resources/slideshow/${data.element_id}`,
    //         })
    //       } else {
    //         this.viewProfile(data.sender_user[0])
    //       }
    //       //this.$router.push({ path: `home/view/post/${data.element_id}/about` });
    //       // console.log(rout,"rout")
    //     }
    //   })
    // },

    notificationRouter(data) {
      this.dropDownVisible = false
      console.log("notificationRouter -> data:", data)
      console.log("data.element_type:", data.element_type)
      const id = data.ext_ref_id ? data.ext_ref_id : data.id

      // element_id should be dovemedpost id - for all types of posts
      AppRepository.readNotifications(id).then(res => {
        if (data.element_type) {
          if (data.element_type == "add to circle") {
            this.viewProfile(data.sender_user[0])
          } else if (["post", "review", "recommend"].includes(data.element_type)) {
            this.$router.push({ name: "NotificationView", params: { type: data.element_type, id: data.element_id } })
          } else if (data.element_type === "say hi") {
            this.$router.push({ name: "NotificationView", params: { type: "post", id: data.element_id } })
          } else if (["job", "event", "poll"].includes(data.element_type)) {
            this.$router.push({ name: "NotificationView", params: { type: data.element_type, id: data.element_id } })
          } else if (["press release", "press"].includes(data.element_type)) {
            this.$router.push({ name: "NotificationView", params: { type: "press", id: data.element_id } })
            // this.$notification.info({ message: "Yet to be added" })
          } else if (data.element_type === "question") {
            this.$router.push({ name: "NotificationView", params: { type: data.element_type, id: data.element_id } })
            // this.$router.push({ name: "ShowSharedQuestion", params: { id: data.element_id } })
          } else if (["comment"].includes(data.element_type)) {
            this.$router.push({ name: "NotificationView", params: { type: data.element_parent_type, id: data.element_parent_id, cmnttype: data.element_type, cmntid: data.element_id } })
            // } else if (["reply"].includes(data.element_type)) {
            //   this.$router.push({ name: "NotificationView", params: { type: data.element_type, id: data.element_id } })
          } else if (["reply"].includes(data.element_type)) {
            this.$router.push({ path: `home/view/${data.element_parent_type}/${data.element_parent_id}/${data.element_type}/${data.element_id}` })
          } else {
            this.viewProfile(data.sender_user[0])
          }
        }
      })
    },

    handleNotifications(e) {
      this.fetchUserNotifications(e)
    },

    goToSelectRolePage() {
      this.setAppLoaderStatus(true)
      AppRepository.getHasMultiRole(this.currentCircle.id)
        .then(res => {
          // if (!res.data.data.length) {
          //   this.$notification.error({ message: "Error", description: "You have only one role for this circle." })
          // } else {
          this.setAppLoaderStatus(false)
          this.$router.push(`/${this.currentCircle.key_name}/select-profile`)
          // }
        })
        .catch(err => {
          this.setAppLoaderStatus(false)
        })
      // this.hasMultiRole(this.currentCircle.id)
      //   ? this.$router.push({ name: "ProfileSelect" })
      //   : this.$notification.error({ message: "Error", description: "You have only one role for this circle." })
    },

    goToAllCirclesPage() {
      this.$router
        .push({
          path: "/searchpage",
          // name: "AllCircles"
        })
        .catch(err => {})
    },

    handleSearchPost() {
      this.showSearchBar = false
      // this.$store.state.Posts.filterPostKey = this.filterPost;
      if (this.filterPost) {
        this.$store.commit("Posts/startPostsSearching")
      } else {
        this.$store.commit("Posts/stopPostsSearching")
      }

      this.$store.commit("Posts/startActivityPostsLoading")

      // console.log("this.$store ->", this.$store);
      // console.log("this.$store.state ->", this.$store.state);
      this.$store.commit("Posts/setFilterSearchKey", this.filterPost)

      this.fetchPosts()
      this.$router.push({
        name: "ActivityHome",
      })
    },
    fetchPosts(append = false) {
      PostRepository.getAll(this.authUser.user.id, this.currentCircle.id, this.currentPage, (this.limit = 10), this.appliedFilters, this.$store.state.Posts.filterPostKey)
        .then(res => {
          // console.log("Header -> fetchPosts -> res.data ==", res.data)
          this.$store.commit("Posts/updatePosts", res.data)
          this.$store.commit("Posts/stopActivityPostsLoading")
        })
        .catch(err => {
          console.log(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.header-app {
  // box-shadow: 8px 5px 11px rgba(51, 51, 51, 0.549);
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1);
  // position: sticky;
  // top: 0;
  // z-index: 100;
}
.dovemed-header {
  height: 65px;
  // height: 80px;
  width: 100%;
  // position: absolute;
  left: 0;
  top: 0;
}

.logo {
  width: 159px;
  align-self: center;
  height: 30px;
  object-fit: contain;
}

.navigator {
  list-style-type: none;
  display: flex;
  align-items: center;

  li {
    color: #fff;
    font-size: 14px;
    display: inline-block;
    text-transform: uppercase;
    padding: 0px 15px;
    // padding: 30px 15px;
    cursor: pointer;

    i {
      font-size: 28px !important;
    }
  }

  .dropdown-btn-class {
    color: #fff;
    font-size: 14px;
    text-transform: uppercase;
    cursor: pointer;
  }
}
.header-user-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.round-img {
  border-radius: 50% !important;
  display: flex;
  flex-shrink: 0;
}
.admin-tag {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.3);
  text-align: center;
  color: #ffffff;
  font-family: Lato;
  font-size: 10px;
  font-weight: bold;
  width: 100px;
  // margin: 0 auto;
}
.ant-dropdown-menu-item:last-child {
  border-bottom: 0px transparent;
}
.switch-roles {
  display: flex;
  justify-content: flex-end;
  font-weight: 600;
}
.current-circle {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
}
// .backdrop-show {
//   width: 20%;
//   background: rgba(0, 0, 0, 0.049);
//   height: 100%;
//   position: fixed;
//   top: 0px;
//   right: 0px;
// }
.notification-sub-heading {
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  margin-bottom: 15px;
  margin-left: 15px;
  color: #333333;
}
.header-search-bar {
  width: 41%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  // width: 35%;
  // position: relative;
  padding-left: 10px;
  @media screen and (max-width: 900px) {
    border-radius: 0px;
    display: none;
    // position: absolute;
    // top: 116px;
    // top: 0px;
    // height: 100%;
    width: 100%;
    // width: -webkit-fill-available;
    // box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1);
    margin: 16px;
    border-radius: 8px;
  }
  &--button {
    border-radius: 6px;
    color: #ffffff;
    padding: 8px 16px;
    // padding: 5px 32px;
    // position: absolute;
    // right: 4px;
    // top: 4px;
    // z-index: 999;
    font-size: 12px;
    border: none;
    font-weight: 700;
    line-height: 20px;

    &:focus {
      outline: none;
    }
  }
}
.notification-dot {
  position: absolute;
  top: -8px;
  left: 7px;
  font-size: 12px;
  // background: #6e56f5;
  padding: 3px;
  border-radius: 80%;
  right: -10px;
  width: 23px;
  display: flex;
  height: 23px;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 600px) {
    left: 27px;
    top: -7px;
    font-size: 10px;
    height: 19px;
    width: 19px;
    color: white;
  }
}

.header-logo {
  @media screen and (max-width: 900px) {
    display: flex;
    flex-direction: column-reverse;
    margin-left: 10px;

    .logo {
      margin-top: 0px;
    }

    .beta {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      margin-right: 45px;

      &-version {
        padding: 2px 4px;
        font-size: 8px;
        line-height: 8px;
        margin-bottom: 0px;
        margin-top: 10px;
      }
    }
  }
}
.notification-dropdown {
  padding-top: 0px !important;
  max-height: max-content !important;
  @media screen and (max-width: 600px) {
    // min-width: 300px;
    min-width: 100vw;
    max-width: 100vw;
    min-height: calc(100vh - 120px);
    top: 120px;
  }
  .ant-dropdown-menu-item {
    border-bottom: none !important;
  }
}
.bell-button-desktop {
  @media screen and (max-width: 900px) {
    display: none;
  }
}
.bell-button-mobile {
  display: none !important;
  @media screen and (max-width: 900px) {
    display: inline-block !important;
  }
}
.tooltip-text {
  visibility: hidden;
  width: 120px;
  // background-color: #2a71d4;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: 150%;
  left: 50%;
  margin-left: -60px;
  font-size: 10px;
  text-transform: capitalize;
}
.iconToHover:hover .tooltip-text {
  visibility: visible;
}
.searchInputMain {
  height: 44px;
  background: none;
  outline: none;
  border: none;
  flex-grow: 1;
  margin-left: 2px;

  &:focus {
    outline: none;
  }
}
.viewCircleBG {
  padding: 12px 24px;
  background: #e2e8f0;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
// .font10 {
//   font-size: 10px !important;
// }
// .gray400 {
//   color: #94a3b8 !important;
// }
// .gray500 {
//   color: #647490 !important;
// }
// .gray800 {
//   color: #1e2945 !important;
// }
.notiOptsContainer {
  padding: 8px 16px;
  right: 0;
  top: 60px;
  p {
    cursor: pointer;
    padding: 6px;
    color: #1e2945 !important;
    font-size: 16px;
    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }
  }
}
.hw24 {
  height: 24px;
  width: 24px;
  display: inline-block;
}
.spinnerContainer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba($color: #000000, $alpha: 0.5);
  z-index: 999;
}
// .header-nav-icon {
//   font-size: 20px !important;
//   @media screen and (max-width: 900px) {
//     font-size: 16px !important;
//   }
// }
.headerHeight {
  height: 65px;
  @media screen and (max-width: 900px) {
    // margin-right: 10px;
    // margin-left: 10px;
    position: relative;
    max-width: 100% !important;
    height: 76px;
  }
}
.show-in-mobile {
  display: none !important;
  @media screen and (max-width: 900px) {
    display: flex !important;
  }
}
.header-myC {
  background-color: rgba(255, 255, 255, 0.15);
  padding: 12px 24px;
  margin-left: 3rem;
  @media screen and (max-width: 900px) {
    margin-left: 0.5rem;
    padding: 6px 12px;
  }
}
.ml-4 {
  @media screen and (max-width: 600px) {
    margin-left: 0.5rem !important;
    margin-right: 16px !important;
  }
}
.mobile-tabs {
  list-style-type: none;
  background: #ffffff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  padding: 8px 16px;
  font-size: 10px;

  div,
  .dropdown-btn-class {
    font-size: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #0f1734 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/App/Header.vue